export enum DateRange {
  // LAST_24_HOURS = "LAST_24_HOURS",
  TODAY = "TODAY",
  TOMORROW = "TOMORROW",
  YESTERDAY = "YESTERDAY",
  THIS_WEEK = "THIS_WEEK",
  // LAST_WEEK= "LAST_WEEK",
  // LAST_30_DAYS = "LAST_30_DAYS",
  THIS_MONTH = "THIS_MONTH",
  // LAST_MONTH = "LAST_MONTH",
  ALL = "ALL",
  CUSTOM_RANGE = "CUSTOM_RANGE",
}
